import { siteChromeNavigationStoreKey } from "./constants";
import {
  updateNavigationTree,
  setNavRefreshedWithNavApiData
} from "@src/template/state/modules/navigation";
import { getOrSetInLocalStorageWithExpiryAsync } from "@src/helpers/webStorage";
import { noticeError } from "@src/helpers/monitoring";
import { getVariantKey } from "./getVariantKey";
import { createFetchClientNavigationWrapper } from "./createFetchClientNavigationWrapper";
import { schedulePersonalisation } from "./schedulePersonalisation";

const getCountryData = store => {
  const {
    regionalStore: {
      countryCode,
      defaultLanguage,
      storeUrls,
      keyStoreDataversion
    },
    layout: { platform }
  } = store.getState();

  return [
    defaultLanguage,
    countryCode,
    storeUrls.default,
    platform,
    keyStoreDataversion
  ];
};

export const reloadNavigation = async store => {
  const { dispatch } = store;
  const [language, countryCode, storeUrl, platform, ksdvFromRegionalStore] =
    getCountryData(store);

  const applyNavData = navData => {
    dispatch(updateNavigationTree(navData));
    dispatch(setNavRefreshedWithNavApiData());
  };

  let navData;

  try {
    navData = await getOrSetInLocalStorageWithExpiryAsync(
      {
        cacheKeyPrefix: siteChromeNavigationStoreKey,
        returnCachedOnDelegateFailure: true,
        removeOtherCacheItems: true,
        localStorageValueDelegate: async (...funcParams) => {
          const variantKey = await getVariantKey();

          return createFetchClientNavigationWrapper(
            storeUrl,
            platform,
            variantKey
          )(...funcParams);
        },
        onStaleCacheValue: applyNavData
      },
      countryCode,
      ksdvFromRegionalStore,
      language
    );
  } catch (error) {
    noticeError(error, { siteChromeNavigation: "nav api refresh failed" });
    return;
  }

  applyNavData(navData);
  schedulePersonalisation({ store, navData });
};
